import { Small } from '@casavo/base-ui'
import cn from 'classnames'
import Link from 'next/link'
import React from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { isEnter } from '@/utils/keyboard-helper'
import { handleListingPageClick } from '@/utils/tracking/eventsHandlers'

import { BREADCRUMBS_ITEM_TEST_ID } from '.'

import { breadcrumbsFakeLink, breadcrumbsLink } from './styles.css'

type Props = {
  href?: string
  isLink: boolean
  isOverflow?: boolean
  onClick?: () => void
  showOnMobile?: boolean
}

/**
 * onClick is used only when isLink = false
 */
const Breadcrumb: React.FC<Props> = ({ children, href, isLink, isOverflow, onClick, showOnMobile = true }) => {
  return isLink ? (
    <Link passHref href={href}>
      <a
        className={cn(
          breadcrumbsLink,
          sprinkles({
            display: {
              desktop: 'inline-block',
              mobile: showOnMobile ? 'inline-block' : 'none',
              tablet: 'inline-block',
            },
          })
        )}
        data-testid={BREADCRUMBS_ITEM_TEST_ID}
        onClick={() => handleListingPageClick('Breadcrumb')}
      >
        <Small>{children}</Small>
      </a>
    </Link>
  ) : (
    <div
      className={cn(
        breadcrumbsFakeLink({ isClickable: typeof onClick !== 'undefined', isOverflow }),
        sprinkles({
          display: {
            desktop: 'inline-block',
            mobile: showOnMobile ? 'inline-block' : 'none',
            tablet: 'inline-block',
          },
        })
      )}
      data-testid={BREADCRUMBS_ITEM_TEST_ID}
      role="button"
      tabIndex={0}
      onClick={() => typeof onClick !== 'undefined' && onClick()}
      onKeyDown={(e) => isEnter(e) && typeof onClick !== 'undefined' && onClick()}
    >
      <Small>{children}</Small>
    </div>
  )
}

export default Breadcrumb
